import { LABORATORY_LPU_TYPE_ID } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/constants'

/**
 * Нужно ли скрыть блок рейтинга врачей для обычных пользователей.
 *
 * Для ЛПУ с типом «Лаборатория (анализы)» при включённом
 * `change_calc_rating_on_laboratory` колонка «Врачи» не показывается:
 * в формулу рейтинга лаборатории врачи не входят.
 *
 * Staff видит блок врачей как раньше — для проверки данных.
 */
export default function shouldHideDoctorsRating(
  changeCalcRatingOnLaboratory: boolean | undefined,
  lpuTypeId: number,
  isStaff?: boolean,
): boolean {
  if (isStaff) {
    return false
  }

  return Boolean(changeCalcRatingOnLaboratory)
    && lpuTypeId === LABORATORY_LPU_TYPE_ID
}
